export default __webpack_public_path__ + "strategic_partners.png";